<script setup lang="ts">
import { useAppVersion } from './useAppVersion';

const { displayVersion } = useAppVersion();
</script>

<template>
	<span
		v-if="displayVersion"
		class="shrink-0 text-label font-medium text-on-surface-muted"
		aria-label="App version"
	>
		{{ displayVersion }}
	</span>
</template>
